import { useChatInputStore, useCoworkerStore } from '@/store';
import { blockIfWorkModeDisabled } from '@/lib/workModeAvailability';
import { selectUseCaseModel } from '@/lib/useCaseModelSelection';
import {
  restoreUseCaseDraft as restoreStoredDraft,
  retainUseCaseDraft,
} from './useCaseDraftHandoff.js';

export { clearUseCaseDraftHandoff, retainUseCaseDraft } from './useCaseDraftHandoff.js';

// Public server-rendered examples open an editable composer, never auto-send.
// Native clients keep the existing implementation and navigation contract.
export function restoreUseCaseDraft(isAuthenticated) {
  const url = new URL(window.location.href);
  const prompt = url.searchParams.get('prompt');
  const mode = url.searchParams.get('mode') || 'chat';
  if (url.pathname === '/app' && prompt?.trim() && prompt.length <= 10000 && ['chat', 'work'].includes(mode)) {
    if (mode === 'work' && blockIfWorkModeDisabled()) return false;
    const modelSlug = url.searchParams.get('model') === 'arya' && mode === 'chat' ? 'arya' : undefined;
    const composer = useChatInputStore.getState();
    composer.setContext('new');
    composer.clearPendingAutoSend();
    composer.setSelectedModels([]);
    composer.setText(prompt);
    useCoworkerStore.getState().setComposerMode(mode === 'work' ? 'coworker' : 'chat');
    selectUseCaseModel(modelSlug);
    if (!isAuthenticated) retainUseCaseDraft(prompt, mode, modelSlug);
    ['prompt', 'mode', 'model'].forEach(key => url.searchParams.delete(key));
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    return true;
  }
  return restoreStoredDraft(isAuthenticated);
}
